export const TEST_REQUEST = 'ASSESSMENT_TEST/TEST_REQUEST'
export const TEST_SUCCESS = 'ASSESSMENT_TEST/TEST_SUCCESS'
export const TEST_ERROR = 'ASSESSMENT_TEST/TEST_ERROR'

export const DELETE_REQUEST = 'ASSESSMENT_TEST/DELETE_REQUEST'
export const DELETE_SUCCESS = 'ASSESSMENT_TEST/DELETE_SUCCESS'
export const DELETE_ERROR = 'ASSESSMENT_TEST/DELETE_ERROR'

export const VISIBILITY_REQUEST = 'ASSESSMENT_TEST/VISIBILITY_REQUEST'
export const VISIBILITY_SUCCESS = 'ASSESSMENT_TEST/VISIBILITY_SUCCESS'
export const VISIBILITY_ERROR = 'ASSESSMENT_TEST/VISIBILITY_ERROR'
